import { motion } from "framer-motion";

/* On phones and touch screens, fade in without sliding: a moving element can tear/ghost
   during scroll on iOS Safari (stale paint frames). Desktop keeps the slide. */
const NO_SLIDE = typeof window !== "undefined" && window.matchMedia("(max-width: 639px), (pointer: coarse)").matches;

export const Reveal = ({ children, delay = 0, y = 26, className = "", once = true }) => (
    <motion.div
        initial={{ opacity: 0, y: NO_SLIDE ? 0 : y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.15 }}
        transition={{ duration: NO_SLIDE ? 0.5 : 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, as: Tag = "span", className = "" }) => (
    <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
            as={Tag}
            className={`block ${className}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.span>
    </span>
);
